<template>
  <div class="aboutus">
    <!-- <img 
    class="banner"
        v-lazy="'https://www.xaryxx.com/images/images2/about.jpg'"> -->
    <img class="banner" src="../../assets/banner/about.jpg" alt="">
    <div>
      <div class="content">
        <div class="box wraps2">
          <div class="leftbox">
            <div class="title animate__animated animate__pulse">
              <div>公司简介</div>
            </div>
            <div class="info">
              <div class="animate__animated animate__slideInLeft">
                <div class="intro">
                  {{ info.companyIntroduction }}
                </div>
                <ul class="circleUl">
                  <li :key="index" v-for="(item, index) in desc">
                    <div class="circle"></div>
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="animate__animated animate__slideInRight">
            <img src="../../assets/s31.jpg" alt="">
            <!-- <img
              src="https://www.xaryxx.com/images/images2/s31.jpg"
              alt=""
              srcset=""
            /> -->
          </div>
        </div>
        <!-- 服务领域 -->
        <div class="lingyu box">
          <div class="names">服务领域</div>
          <div class="imgBoxs">
            <div>
              <span>政府</span>
              <img src="https://www.xaryxx.com/images/images2/s32.png" alt="" />
            </div>
            <div>
              <span>能源</span>
              <img src="https://www.xaryxx.com/images/images2/s33.png" alt="" />
            </div>
            <div>
              <span>制造</span>
              <img src="https://www.xaryxx.com/images/images2/s34.png" alt="" />
            </div>
            <div>
              <span>教育</span>
              <img src="https://www.xaryxx.com/images/images2/s35.png" alt="" />
            </div>
            <div>
              <span>地产</span>
              <img src="https://www.xaryxx.com/images/images2/s36.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="yuanjing">
        <img src="../../assets/s37.jpg" alt="" />
        <div class="words">
          <div class="name">企业愿景</div>
          <div class="desc1">
            <span v-html="info.companyVision"></span>
          </div>
        </div>
        <!-- <div class="box">
          <img
            class="animate__animated animate__slideInLeft"
            v-show="qudaoShow"
            src="https://www.xaryxx.com/images/about/2.png"
            alt=""
            srcset=""
          />
          <div
            v-show="qudaoShow"
            class="details animate__animated animate__slideInRight"
          >
            <div class="name">企业愿景</div>
            <div class="line"></div>
            <div class="desc1">
              <span v-html="info.companyVision"></span>
            </div>
          </div>
        </div> -->
      </div>

      <div class="content">
        <div class="box title" style="margin-bottom: 40px">
          <div class="title" style="padding: 74px 0 50px">公司地址</div>
          <!-- <div class="line"></div> -->
        </div>

        <div class="box mapBox">
          <div v-show="deviceShow" class="infobox animate__animated animate__slideInLeft">
            <div>
              <div class="zh">西安荣业信息科技有限公司</div>
              <div class="en">Xi 'an Rongye lnformation Technology Co.,LTD</div>
              <div class="Certificates">
                {{ info.companySlogan }}
              </div>
            </div>
            <div class="infos">
              <div>公司地址：{{ info.companyAddress }}</div>
              <div>联系电话：{{ info.phone }}</div>
              <div>电子邮箱：{{ info.email }}</div>
            </div>
          </div>
          <div v-show="deviceShow" id="allmap" ref="mapContainer"
            class="allmap animate__animated animate__slideInRight"></div>
        </div>

        <div style="background: #ffede3; margin-top: 80px;" class="content">
          <div class="box">
            <div class="title" style="padding:60px 0">
              <div>欢迎留言</div>
            </div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <div class="searchitems">
                <el-form-item prop="name">
                  <el-input placeholder="请输入您的姓名" v-model="ruleForm.name"></el-input>
                </el-form-item>

                <el-form-item prop="contactInformation">
                  <el-input placeholder="请输入联系方式（手机、邮箱、QQ号码）" v-model="ruleForm.contactInformation"></el-input>
                </el-form-item>
              </div>
              

              <el-form-item prop="remark">
                <el-input placeholder="请填写10个字以上的问题描述以便我们提供更好的帮助" type="textarea" v-model="ruleForm.remark"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button class="sub" type="warning" @click="submitForm('ruleForm')">提交</el-button>
                <el-button class="clean" @click="resetForm('ruleForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { companyInfo } from "@/api/api";
export default {
  name: "abouts",
  data() {
    return {

      map: null, // 地图实例
      marker: null, // 标记实例
      ruleForm: {
        name: "",
        contactInformation: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请填写您的姓名", trigger: "blur" }],
        contactInformation: [
          {
            required: true,
            message: "联系方式（手机、邮箱、QQ号码）",
            trigger: "blur",
          },
        ],
      },
      desc: [
        "营销、内容、创意、技术、研发等多维度",
        "综合型数字化创新服务",
        "服务于政府、能源、制造、教育、地产领域",
      ],
      info: {},
      navList: [
        { label: "公司简介", value: 0 },
        { label: "荣誉资质", value: 1 },
        { label: "知识产权", value: 2 },
      ],
      current: 0,
      companyData: {},
      companyVision: {},
      companyCulture: [],
      companyPurpose: {},
      honorList: [],
      propertyRight: [],
      bannerList: [],
      qudaoShow: false,
      deviceShow: false,
    };
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrolling);
  },

  created() {
    window.addEventListener("scroll", this.scrolling);

    let self = this;
    let query = self.$route.query;
    if (query.current) {
      self.current = query.current;
    }
  },
  beforeDestroy() {
    // 组件销毁时清理地图资源，防止内存泄漏
    if (this.marker) {
      this.map.remove(this.marker)
      this.marker = null
    }
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  },
  mounted() {
    this.getcompanyInfo();
    this.$nextTick(() => {
      this.initMap()
    })
  },
  methods: {

    // 初始化地图
    initMap() {
      // 检查高德地图 API 是否加载完成
      if (!window.AMap) {
        console.error('高德地图 API 未加载，请在 index.html 中引入')
        return
      }

      // 创建地图实例
      this.map = new AMap.Map(this.$refs.mapContainer, {
        zoom: 17,
        center: new AMap.LngLat(108.970937, 34.321173),
        resizeEnable: true
      })

      // 初始化自定义标记
      this.initCustomMarker()
    },

    // 初始化自定义 HTML 标记
    initCustomMarker() {
      const position = new AMap.LngLat(108.970937, 34.321173)

      // 自定义标记的 HTML 内容（和原生版一致）
      const markerContent = `
        <div class="custom-content-marker">
          <img style="width:30px;height:30px;" src="../../../static/banner/2.png">
          </div>
      `

      // 创建标记实例
      this.marker = new AMap.Marker({
        position: position,
        content: markerContent, // 传入自定义 HTML 内容
        offset: new AMap.Pixel(-13, -30) // 偏移量（和原生版一致）
      })

      // 将标记添加到地图
      this.map.add(this.marker)


    },



    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submit(this.ruleForm)
            .then((result) => {
              4;
              if (result.code == 200) {
                this.$message({
                  message: result.msg,
                  type: "success",
                });

                setTimeout(() => {
                  this.resetForm("ruleForm");
                }, 1500);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    scrolling(e) {
      const winHeight =
        e.target.scrollTop || document.documentElement.scrollTop;
      console.log(winHeight, 222222222222);
      if (winHeight >= 200) {
        this.qudaoShow = true;
      }
      if (winHeight >= 900) {
        this.deviceShow = true;
      }
    },
    contact() {
      this.$router.push({ path: "/pages/service/sub" });
    },

    getcompanyInfo() {
      companyInfo().then((response) => {
        this.info = response.data;

        // setTimeout(function () {
        //   var map = new BMapGL.Map("allmap");

        //   map.centerAndZoom(new BMapGL.Point(108.977345, 34.328004), 12);
        //   //创建地址解析器实例
        //   var myGeo = new BMapGL.Geocoder();
        //   //创建地址解析器实例
        //   var myGeo = new BMapGL.Geocoder();
        //   // 将地址解析结果显示在地图上，并调整地图视野
        //   myGeo.getPoint(
        //     response.data.companyAddress,
        //     function (point) {
        //       if (point) {
        //         map.centerAndZoom(point, 19);
        //         map.addOverlay(new BMapGL.Marker(point, { title: "西安荣业" }));
        //       } else {
        //         alert("您选择的地址没有解析到结果！");
        //       }
        //     },
        //     "西安市"
        //   );
        // }, 2000);
      });
    },
    showContent: function (current) {
      this.current = current;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.custom-content-marker {
  position: relative;
  width: 25px;
  height: 34px;
}

.custom-content-marker img {
  width: 100%;
  height: 100%;
}


.yuanjing {
  margin: 162px 0 71px 0;
  position: relative;

  img {
    display: block;
    width: 100%;
  }

  .words {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;

    .name {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 30px;
      color: #ffffff;
      margin-bottom: 86px;
    }
  }

  // height: 297px;
  // background: #fafafa linear-gradient(136deg, #ff3d00 0%, #ff9f0e 100%);

  // .box {
  //   display: flex;
  //   align-items: center;

  //   img {
  //     margin-top: -37px;
  //   }
  // }

  // .details {
  //   margin-left: 91px;

  //   .name {
  //     font-size: 30px;
  //     font-family: PingFang SC-Medium, PingFang SC;
  //     font-weight: 500;
  //     color: #ffffff;
  //     line-height: 35px;
  //   }

  //   .line {
  //     height: 5px;
  //     width: 49px;
  //     background: #ffffff;
  //     margin: 10px 0 38px 0;
  //   }
  //   .desc1 {
  //     width: 536px;
  //     font-size: 17px;
  //     font-family: PingFang SC-Medium, PingFang SC;
  //     font-weight: 500;
  //     color: #ffffff;
  //     line-height: 27px;
  //   }
  // }
}

.demo-ruleForm {
  padding-bottom: 80px;
  // padding: 60px 0 55px 0;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;

  .sub {
    width: 120px;
    height: 50px;
    background: #ff6019;
    border-radius: 25px;
    border: 2px solid transparent;
    font-size: 18px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-right: 30px;
  }

  .clean {
    font-size: 18px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF6019;
    width: 120px;
    height: 50px;
    background: none;
    border-radius: 25px;
    border: 2px solid #ff6019;
  }

  .searchitems {
    display: flex;

    .el-form-item {
      flex: 1;

      &:nth-child(1) {
        margin-right: 23px;
      }
    }
  }

  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    background: #fff !important;
    box-shadow: 0px 0px 16px 0px rgba(202, 112, 63, 0.19);
  }

  /deep/ .el-textarea__inner {
    margin-top: 15px;
    margin-bottom: 30px;
    height: 266px;
  }
}

.title {
  // padding-top: 71px;
  text-align: center;

  font-family: PingFang SC;
  font-weight: bold;
  font-size: 30px;
  color: #090909;
  line-height: 35px;

  .line {
    text-align: center;
    margin-top: 7px;
    width: 49px;
    height: 5px;
    background: linear-gradient(360deg, #ff8400 0%, #e32200 100%);
    border-radius: 0px 0px 0px 0px;
  }
}

.aboutus {
  padding-top: 120px;

  .banner {
    display: block;
    width: 100%;
  }

  .lingyu {
    .names {
      padding: 100px 0 60px;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #000000;
      line-height: 21px;
      text-align: center;
    }

    .imgBoxs {
      display: flex;
      align-items: center;

      >div {
        position: relative;
        margin-right: 25px;

        &:last-child {
          margin-right: 0;
        }

        flex: 1;

        img {
          width: 100%;
          display: block;
        }

        span {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #ffffff;
        }
      }
    }
  }
}

.btn {
  cursor: pointer;
  margin-top: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  width: 180px;
  height: 60px;
  margin-left: 17px;
  background: linear-gradient(136deg, #ff3d00 0%, #ff9f0e 100%);
  border-radius: 77px 77px 77px 77px;
}

.circleUl {
  margin: 25px 0 0 17px;
  padding: 0;

  li {
    list-style-type: none;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
    display: flex;
    align-items: center;

    .circle {
      margin-right: 10px;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      background: url("https://www.xaryxx.com/images/images2/s28.png") no-repeat;
      background-size: cover;
      // background: #f14f02;
    }
  }
}

.wraps2 {
  background: #ffffff;
  display: flex;
  align-items: flex-end;
  padding-top: 297px;

  .leftbox {
    height: 415px;
    padding: 82px 66px 0 57px;
    flex: 1;
    box-shadow: 0px 0px 21px 0px rgba(195, 193, 192, 0.36);
  }

  img {
    width: 586px;
    height: 693px;
    display: block;
    margin-top: -384px;
  }
}

.info {
  display: flex;

  .intro {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 23px;
    margin-top: 48px;
    // padding: 40px 52px 47px 17px;
  }
}

.mapBox {
  display: flex;

  .allmap {
    height: 350px;
    width: 55%;
    // border: 6px solid rgba(0, 0, 0, 0.13);
    border-radius: 10px;
  }

  .infobox {
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: space-between;
    justify-content: space-between;
    height: 320px;
    margin-right: 50px;

    .Certificates {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #090909;
      line-height: 24px;
    }

    .zh {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #090909;
      line-height: 24px;
      // font-size: 25px;
      // font-family: PingFang SC-Regular, PingFang SC;
      // font-weight: 400;
      // line-height: 37px;
      // background: linear-gradient(360deg, #ff8400 0%, #e32200 100%);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }

    .en {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #090909;
      line-height: 24px;
      margin: 15px 0;
      // font-size: 16px;
      // font-family: PingFang SC-Regular, PingFang SC;
      // font-weight: 400;
      // color: #898989;
      // line-height: 37px;
    }

    .infos>div {
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 23px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.box {
  width: 80rem;
  margin: 0 auto;
}

.content {
  // display: flex;
  // justify-content: space-around;
}

.display-flex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/abouts/index.vue